export default "__VITE_ASSET__f9030ab9__"